import { render, staticRenderFns } from "./detailSystemParameter.vue?vue&type=template&id=ca447cb2&scoped=true&"
import script from "./detailSystemParameter.vue?vue&type=script&lang=js&"
export * from "./detailSystemParameter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca447cb2",
  null
  
)

export default component.exports